import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import toast from "react-hot-toast";
import { fr } from "yup-locales";
import { setLocale } from "yup";
import { Roles, User, UserFormData } from "@/redux/services/user/user.type";
import { useCreateOrUpdateUserMutation } from "@/redux/services/user/user.api";
import { cleanerError } from "@/lib/utils";
import { toastApiError } from "@/lib/apiErrors";

setLocale(fr);

export const userValidationschema = yup.object().shape({
  fullName: yup.string().required().label("Nom"),
  phone: yup.string().required().label("Téléphone"),
  email: yup.string().email("Ce champ doit être une adresse e-mail valide"),
  roles: yup.array().required().label("Type"),
});

export const useCrudUser = (closeModal: () => void, item?: User, restaurantId?: string) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    clearErrors,
    setValue,
  } = useForm<UserFormData>({
    resolver: yupResolver(userValidationschema),
    defaultValues: {
      roles: item ? item?.roles : [Roles.waiter],
    },
  });

  const [createOrUpdate, { isLoading }] = useCreateOrUpdateUserMutation();
  const [selectRole, setSelectedRole] = useState<Roles>(
    item?.roles?.find((role) => role !== Roles.user) as Roles
  );

  useEffect(() => {
    if (errors) {
      cleanerError(errors, clearErrors);
    }
  }, [errors, clearErrors]);

  const onSelectRoles = (e: React.FormEvent<HTMLSelectElement>) => {
    const value = e.currentTarget.value as Roles;
    setValue("roles", [value]);
    setSelectedRole(value);
  };

  const onSubmit = async (data: UserFormData) => {
    if (!data?.email?.trim()) delete data.email;
    const payload = restaurantId && !item?.id
      ? { ...data, restaurant: restaurantId }
      : data;
    const res = await createOrUpdate({
      id: item?.id,
      // @ts-ignore
      data: payload,
      ...(restaurantId ? { restaurantId } : {}),
    });

    if ("data" in res) {
      closeModal();
      toast.success(
        `Utilisateur ${item?.id ? "modifié" : "ajouté"}  avec succès`
      );
      reset();
    } else if ("error" in res) {
      toastApiError(res.error, "Une erreur inconnue est survenue");
    }
  };

  return {
    register,
    errors,
    onSubmit: handleSubmit(onSubmit),
    isLoading,
    onSelectRoles,
    selectRole,
  };
};
